// // src/components/layout/Sidebar.jsx
// import React, { useState, useEffect, useRef } from 'react';
// import { NavLink, Link, useNavigate, useLocation } from 'react-router-dom';
// import {
//   FaUser,
//   FaPalette,
//   FaStore,
//   FaExchangeAlt,
//   FaBars,
//   FaTimes,
//   FaHeadset,
//   FaHome,
//   FaFolderOpen,
//   FaChartLine,
//   FaEnvelope,
//   FaCreditCard,
//   FaShoppingCart,
//   FaHistory,
//   FaClipboardList,
//   FaFileAlt,
//   FaUsers,
//   FaFlag,
//   FaUserCheck,
//   FaMoneyBillWave,
//   FaBoxOpen,
//   FaTruck,
//   FaSignOutAlt,
//   FaBell,
//   FaSearch,
//   FaChevronRight,
// } from 'react-icons/fa';
// import Logo from '../../assets/logo7.png';
// import '../../styles/sidebar.scss';
// import { toast } from 'react-toastify';
// import { serverUrlAuth } from '../../serverUrl';

// export default function Sidebar() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [user, setUser] = useState(null);
//   const [currentMode, setCurrentMode] = useState('custom');
//   const [mobileOpen, setMobileOpen] = useState(false);

//   // Load user info from localStorage
//   useEffect(() => {
//     const token = localStorage.getItem('access_token');
//     const role = localStorage.getItem('role');
//     const fullName = localStorage.getItem('full_name');
//     const savedMode = localStorage.getItem('user_mode') || 'custom';

//     if (token && role) {
//       setUser({ role, name: fullName });
//       setCurrentMode(savedMode);
//     } else {
//       setUser(null);
//     }
//   }, [location.pathname]);

//   // Detect current mode based on URL path
//   useEffect(() => {
//     const p = location.pathname;
//     if (
//       p.includes('/artisan-dashboard') ||
//       p.includes('/browse-project-requests') ||
//       p.includes('/my-proposals') ||
//       p.includes('/artisan-profile') ||
//       p.includes('/my-projects') ||
//       p.includes('/messaging')
//     ) {
//       setCurrentMode('custom');
//     } else if (
//       p.includes('/artisan-ready-products') ||
//       p.includes('/artisan-product-management') ||
//       p.includes('/orders') ||
//       p.includes('/artisan-earnings')
//     ) {
//       setCurrentMode('shop');
//     } else if (p.includes('/ready-made-products') || p.includes('/cart')) {
//       setCurrentMode('shop');
//     } else if (
//       p.includes('/client-dashboard') ||
//       p.includes('/projects') ||
//       p.includes('/project-updates')
//     ) {
//       setCurrentMode('custom');
//     }
//   }, [location.pathname]);

//   // Close mobile drawer on route change
//   useEffect(() => {
//     setMobileOpen(false);
//   }, [location.pathname]);

//   // Body class so main content shifts right on desktop
//   useEffect(() => {
//     if (user) document.body.classList.add('sidebar-active');
//     else document.body.classList.remove('sidebar-active');
//     return () => document.body.classList.remove('sidebar-active');
//   }, [user]);

//   const handleClientSwitch = () => {
//     const newMode = currentMode === 'custom' ? 'shop' : 'custom';
//     localStorage.setItem('user_mode', newMode);
//     setCurrentMode(newMode);
//     if (newMode === 'custom') {
//       navigate('/client-dashboard');
//       toast.info('Switched to Custom Orders');
//     } else {
//       navigate('/ready-made-products');
//       toast.info('Switched to Ready-Made Shop');
//     }
//   };

//   const handleArtisanSwitch = () => {
//     const newMode = currentMode === 'custom' ? 'shop' : 'custom';
//     localStorage.setItem('user_mode', newMode);
//     setCurrentMode(newMode);
//     if (newMode === 'custom') {
//       navigate('/artisan-dashboard');
//       toast.info('Switched to Custom Projects');
//     } else {
//       navigate('/artisan-ready-products');
//       toast.info('Switched to Ready-Made Shop');
//     }
//   };

//   const handleLogout = async () => {
//     try {
//       const token = localStorage.getItem('fcm_token');
//       if (token) {
//         await serverUrlAuth.post('/notifications/remove-push-token/', {
//           token,
//         });
//       }
//     } catch (error) {
//       console.error(error);
//     }

//     [
//       'access_token',
//       'refresh_token',
//       'role',
//       'full_name',
//       'fcm_token',
//       'user_mode',
//     ].forEach((k) => localStorage.removeItem(k));

//     setUser(null);
//     document.body.classList.remove('sidebar-active');
//     navigate('/login');
//     toast.success('Logout successful');
//   };

//   const handleHelpDeskClick = () => {
//     if (user?.role === 'admin') navigate('/support');
//     else if (user?.role === 'client') navigate('/client-help-desk');
//     else navigate('/artisan-help-desk');
//   };

//   const shouldShowModeSwitch =
//     user && (user.role === 'client' || user.role === 'artisan');

//   // Grouped nav
//   const getNavGroups = () => {
//     if (!user) return [];

//     if (user.role === 'client' && currentMode === 'custom') {
//       return [
//         {
//           label: 'Overview',
//           items: [
//             {
//               to: '/client-dashboard',
//               icon: <FaHome />,
//               label: 'Dashboard',
//               tourClass: 'tour-dashboard',
//             },
//             {
//               to: '/projects',
//               icon: <FaFolderOpen />,
//               label: 'My Projects',
//               tourClass: 'tour-projects',
//             },
//             {
//               to: '/project-updates',
//               icon: <FaChartLine />,
//               label: 'Project Progress',
//               tourClass: 'tour-progress',
//             },
//           ],
//         },
//         {
//           label: 'Communication',
//           items: [
//             {
//               to: '/messages',
//               icon: <FaEnvelope />,
//               label: 'Messages',
//               tourClass: 'tour-messages',
//             },
//             {
//               to: '/payments',
//               icon: <FaCreditCard />,
//               label: 'Payments',
//               tourClass: 'tour-payments',
//             },
//           ],
//         },
//       ];
//     }

//     if (user.role === 'client' && currentMode === 'shop') {
//       return [
//         {
//           label: 'Shop',
//           items: [
//             {
//               to: '/ready-made-products',
//               icon: <FaStore />,
//               label: 'Browse',
//               tourClass: 'tour-shop',
//             },
//             { to: '/cart', icon: <FaShoppingCart />, label: 'Cart' },
//             {
//               to: '/order-history',
//               icon: <FaHistory />,
//               label: 'Purchases History',
//             },
//           ],
//         },
//       ];
//     }

//     if (user.role === 'artisan' && currentMode === 'custom') {
//       return [
//         {
//           label: 'Overview',
//           items: [
//             {
//               to: '/artisan-dashboard',
//               icon: <FaHome />,
//               label: 'Dashboard',
//               tourClass: 'tour-dashboard',
//             },
//             {
//               to: '/browse-project-requests',
//               icon: <FaClipboardList />,
//               label: 'Browse Projects',
//               tourClass: 'tour-browse-projects',
//             },
//           ],
//         },
//         {
//           label: 'Work',
//           items: [
//             {
//               to: '/my-projects',
//               icon: <FaFolderOpen />,
//               label: 'Ongoing Projects',
//               tourClass: 'tour-my-projects',
//             },
//             {
//               to: '/my-proposals',
//               icon: <FaFileAlt />,
//               label: 'Sent Proposals',
//               tourClass: 'tour-my-proposals',
//             },
//           ],
//         },
//         {
//           label: 'Communication',
//           items: [
//             {
//               to: '/messaging',
//               icon: <FaEnvelope />,
//               label: 'Messages',
//               tourClass: 'tour-messages',
//             },
//             {
//               to: '/artisan-payments',
//               icon: <FaCreditCard />,
//               label: 'Payments',
//               tourClass: 'tour-payments',
//             },
//           ],
//         },
//       ];
//     }

//     if (user.role === 'artisan' && currentMode === 'shop') {
//       return [
//         {
//           label: 'Shop',
//           items: [
//             {
//               to: '/artisan-ready-products',
//               icon: <FaBoxOpen />,
//               label: 'My Products',
//             },
//             { to: '/orders', icon: <FaTruck />, label: 'Orders' },
//             {
//               to: '/artisan-earnings',
//               icon: <FaMoneyBillWave />,
//               label: 'Earnings',
//             },
//           ],
//         },
//       ];
//     }

//     if (user.role === 'admin') {
//       return [
//         {
//           label: 'Overview',
//           items: [
//             { to: '/admin-dashboard', icon: <FaHome />, label: 'Dashboard' },
//           ],
//         },
//         {
//           label: 'Management',
//           items: [
//             { to: '/users-management', icon: <FaUsers />, label: 'Users' },
//             {
//               to: '/projects-management',
//               icon: <FaFolderOpen />,
//               label: 'Projects',
//             },
//             {
//               to: '/artisan-applications',
//               icon: <FaUserCheck />,
//               label: 'Artisan Applications',
//             },
//             { to: '/flagged-messages', icon: <FaFlag />, label: 'Flagged' },
//           ],
//         },
//         {
//           label: 'Finance',
//           items: [
//             {
//               to: '/financials',
//               icon: <FaMoneyBillWave />,
//               label: 'Financials',
//             },
//             {
//               to: '/disbursements',
//               icon: <FaCreditCard />,
//               label: 'Disbursements',
//             },
//           ],
//         },
//       ];
//     }

//     return [];
//   };

//   if (!user) return null;

//   const navGroups = getNavGroups();
//   const initials = (user.name || 'A')
//     .split(' ')
//     .map((n) => n[0])
//     .slice(0, 2)
//     .join('')
//     .toUpperCase();

//   const roleLabel =
//     user.role === 'admin'
//       ? 'Administrator'
//       : user.role === 'artisan'
//         ? currentMode === 'custom'
//           ? 'Artisan · Custom'
//           : 'Artisan · Shop'
//         : currentMode === 'custom'
//           ? 'Client · Custom'
//           : 'Client · Shop';

//   const profilePath =
//     user.role === 'artisan'
//       ? '/artisan-profile'
//       : user.role === 'client'
//         ? '/Profile'
//         : '/admin-profile';

//   return (
//     <>
//       {/* Mobile top bar */}
//       <div className="sidebar-mobile-topbar d-lg-none">
//         <button
//           className="sidebar-hamburger"
//           onClick={() => setMobileOpen(true)}
//           aria-label="Open menu"
//         >
//           <FaBars />
//         </button>
//         <Link to="/" className="sidebar-mobile-logo">
//           <img src={Logo} alt="Artiza logo" className="logo" />
//         </Link>
//         <div className="sidebar-mobile-spacer" />
//       </div>

//       {/* Mobile backdrop */}
//       {mobileOpen && (
//         <div
//           className="sidebar-backdrop d-lg-none"
//           onClick={() => setMobileOpen(false)}
//         />
//       )}

//       <aside className={`artiza-sidebar ${mobileOpen ? 'open' : ''}`}>
//         {/* ============ HEADER ============ */}
//         <div className="sidebar-header">
//           <Link to="/" className="sidebar-logo">
//             <div className="logo-mark">
//               <img src={Logo} alt="Artiza logo" className="logo" />
//             </div>
//             <span className="logo-text">Artiza</span>
//           </Link>
//           <button
//             className="sidebar-close d-lg-none"
//             onClick={() => setMobileOpen(false)}
//             aria-label="Close menu"
//           >
//             <FaTimes />
//           </button>
//         </div>

//         {/* ============ NAV ============ */}
//         <nav className="sidebar-nav">
//           {navGroups.map((group, gi) => (
//             <div key={gi} className="nav-group">
//               <span className="nav-group-label">{group.label}</span>
//               {group.items.map((item, ii) => (
//                 <SidebarLink
//                   key={ii}
//                   to={item.to}
//                   icon={item.icon}
//                   label={item.label}
//                   tourClass={item.tourClass}
//                   badge={item.badge}
//                 />
//               ))}
//             </div>
//           ))}
//         </nav>

//         {/* ============ FOOTER ============ */}
//         <div className="sidebar-footer">
//           {shouldShowModeSwitch && (
//             <button
//               className="mode-switch-btn tour-mode-switch"
//               onClick={
//                 user.role === 'client'
//                   ? handleClientSwitch
//                   : handleArtisanSwitch
//               }
//             >
//               <span className="switch-icon">
//                 <FaExchangeAlt />
//               </span>
//               <span className="switch-text">
//                 {currentMode === 'custom' ? 'Shop Mode' : 'Custom Mode'}
//               </span>
//               <FaChevronRight className="switch-arrow" />
//             </button>
//           )}

//           <button
//             className="help-desk-btn tour-help-desk"
//             onClick={handleHelpDeskClick}
//           >
//             <FaHeadset className="hd-icon" />
//             <span>Help Desk</span>
//           </button>

//           {/* Profile + Logout — always visible, no dropdown */}
//           <div className="footer-actions">
//             <NavLink
//               to={profilePath}
//               className={({ isActive }) =>
//                 `footer-action-btn tour-user-menu ${isActive ? 'active' : ''}`
//               }
//             >
//               <FaUser className="fa-icon" />
//               <span>Profile</span>
//             </NavLink>

//             <button
//               onClick={handleLogout}
//               className="footer-action-btn logout"
//               type="button"
//             >
//               <FaSignOutAlt className="fa-icon" />
//               <span>Logout</span>
//             </button>
//           </div>
//         </div>
//       </aside>
//     </>
//   );
// }

// function SidebarLink({ to, icon, label, tourClass = '', badge }) {
//   return (
//     <NavLink
//       to={to}
//       className={({ isActive }) =>
//         `sidebar-link ${tourClass} ${isActive ? 'active' : ''}`
//       }
//     >
//       <span className="sidebar-link-icon">{icon}</span>
//       <span className="sidebar-link-label">{label}</span>
//       {badge ? <span className="sidebar-link-badge">{badge}</span> : null}
//       <span className="sidebar-link-indicator" />
//     </NavLink>
//   );
// }


// src/components/layout/Sidebar.jsx

import React, { useState, useEffect } from 'react';
import {
  NavLink,
  Link,
  useNavigate,
  useLocation,
} from 'react-router-dom';

import {
  FaUser,
  FaPalette,
  FaStore,
  FaExchangeAlt,
  FaBars,
  FaTimes,
  FaHeadset,
  FaHome,
  FaFolderOpen,
  FaChartLine,
  FaEnvelope,
  FaCreditCard,
  FaShoppingCart,
  FaHistory,
  FaClipboardList,
  FaFileAlt,
  FaUsers,
  FaFlag,
  FaUserCheck,
  FaMoneyBillWave,
  FaBoxOpen,
  FaTruck,
  FaSignOutAlt,
  FaBell,
  FaSearch,
  FaChevronRight,
} from 'react-icons/fa';

import Logo from '../../assets/logo7.png';
import '../../styles/sidebar.scss';
import { toast } from 'react-toastify';
import { serverUrlAuth } from '../../serverUrl';

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [user, setUser] = useState(null);
  const [currentMode, setCurrentMode] = useState('custom');
  const [mobileOpen, setMobileOpen] = useState(false);

  // Total unread messages across all conversations
  const [unreadMessages, setUnreadMessages] = useState(0);

  // ============================================================
  // FETCH UNREAD MESSAGE COUNT
  // ============================================================

  const fetchUnreadMessages = async () => {
  try {
    const response = await serverUrlAuth.get(
      'negotiations/inbox/'
    );

    const conversations = Array.isArray(response.data)
      ? response.data
      : [];

    console.log(
      'FIRST CONVERSATION:',
      conversations[0]
    );

    console.log(
      'UNREAD FIELDS:',
      conversations.map((conversation) => ({
        id: conversation.id,
        proposal: conversation.proposal,
        unread_count: conversation.unread_count,
        negotiation_unread:
          conversation.negotiation_unread,
        project_unread:
          conversation.project_unread,
      }))
    );

    const totalUnread = conversations.reduce(
      (total, conversation) =>
        total + Number(conversation.unread_count || 0),
      0
    );

    console.log(
      'TOTAL UNREAD:',
      totalUnread
    );

    setUnreadMessages(totalUnread);
  } catch (error) {
    console.error(
      'Error fetching unread messages:',
      error.response?.data || error
    );
  }
};
  // ============================================================
  // LOAD USER INFO FROM LOCAL STORAGE
  // ============================================================

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    const role = localStorage.getItem('role');
    const fullName = localStorage.getItem('full_name');
    const savedMode =
      localStorage.getItem('user_mode') || 'custom';

    if (token && role) {
      setUser({
        role,
        name: fullName,
      });

      setCurrentMode(savedMode);
    } else {
      setUser(null);
      setUnreadMessages(0);
    }
  }, [location.pathname]);

  // ============================================================
  // FETCH UNREAD MESSAGES
  // ============================================================

  useEffect(() => {
    if (!user) {
      setUnreadMessages(0);
      return;
    }

    // Fetch immediately
    fetchUnreadMessages();

    // Refresh every 10 seconds
    const interval = setInterval(() => {
      fetchUnreadMessages();
    }, 10000);

    return () => clearInterval(interval);
  }, [user]);

  // ============================================================
  // DETECT CURRENT MODE BASED ON URL
  // ============================================================

  useEffect(() => {
    const p = location.pathname;

    if (
      p.includes('/artisan-dashboard') ||
      p.includes('/browse-project-requests') ||
      p.includes('/my-proposals') ||
      p.includes('/artisan-profile') ||
      p.includes('/my-projects') ||
      p.includes('/messaging')
    ) {
      setCurrentMode('custom');
    } else if (
      p.includes('/artisan-ready-products') ||
      p.includes('/artisan-product-management') ||
      p.includes('/orders') ||
      p.includes('/artisan-earnings')
    ) {
      setCurrentMode('shop');
    } else if (
      p.includes('/ready-made-products') ||
      p.includes('/cart')
    ) {
      setCurrentMode('shop');
    } else if (
      p.includes('/client-dashboard') ||
      p.includes('/projects') ||
      p.includes('/project-updates')
    ) {
      setCurrentMode('custom');
    }
  }, [location.pathname]);

  // ============================================================
  // CLOSE MOBILE DRAWER ON ROUTE CHANGE
  // ============================================================

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  // ============================================================
  // BODY CLASS
  // ============================================================

  useEffect(() => {
    if (user) {
      document.body.classList.add('sidebar-active');
    } else {
      document.body.classList.remove('sidebar-active');
    }

    return () => {
      document.body.classList.remove('sidebar-active');
    };
  }, [user]);

  // ============================================================
  // CLIENT MODE SWITCH
  // ============================================================

  const handleClientSwitch = () => {
    const newMode =
      currentMode === 'custom' ? 'shop' : 'custom';

    localStorage.setItem('user_mode', newMode);
    setCurrentMode(newMode);

    if (newMode === 'custom') {
      navigate('/client-dashboard');
      toast.info('Switched to Custom Orders');
    } else {
      navigate('/ready-made-products');
      toast.info('Switched to Ready-Made Shop');
    }
  };

  // ============================================================
  // ARTISAN MODE SWITCH
  // ============================================================

  const handleArtisanSwitch = () => {
    const newMode =
      currentMode === 'custom' ? 'shop' : 'custom';

    localStorage.setItem('user_mode', newMode);
    setCurrentMode(newMode);

    if (newMode === 'custom') {
      navigate('/artisan-dashboard');
      toast.info('Switched to Custom Projects');
    } else {
      navigate('/artisan-ready-products');
      toast.info('Switched to Ready-Made Shop');
    }
  };

  // ============================================================
  // LOGOUT
  // ============================================================

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('fcm_token');

      if (token) {
        await serverUrlAuth.post(
          '/notifications/remove-push-token/',
          {
            token,
          }
        );
      }
    } catch (error) {
      console.error(error);
    }

    [
      'access_token',
      'refresh_token',
      'role',
      'full_name',
      'fcm_token',
      'user_mode',
    ].forEach((key) => {
      localStorage.removeItem(key);
    });

    setUser(null);
    setUnreadMessages(0);

    document.body.classList.remove('sidebar-active');

    navigate('/login');

    toast.success('Logout successful');
  };

  // ============================================================
  // HELP DESK
  // ============================================================

  const handleHelpDeskClick = () => {
    if (user?.role === 'admin') {
      navigate('/support');
    } else if (user?.role === 'client') {
      navigate('/client-help-desk');
    } else {
      navigate('/artisan-help-desk');
    }
  };

  // ============================================================
  // MODE SWITCH VISIBILITY
  // ============================================================

  const shouldShowModeSwitch =
    user &&
    (user.role === 'client' ||
      user.role === 'artisan');

  // ============================================================
  // NAVIGATION GROUPS
  // ============================================================

  const getNavGroups = () => {
    if (!user) return [];

    // ========================================================
    // CLIENT — CUSTOM MODE
    // ========================================================

    if (
      user.role === 'client' &&
      currentMode === 'custom'
    ) {
      return [
        {
          label: 'Overview',
          items: [
            {
              to: '/client-dashboard',
              icon: <FaHome />,
              label: 'Dashboard',
              tourClass: 'tour-dashboard',
            },
            {
              to: '/projects',
              icon: <FaFolderOpen />,
              label: 'My Projects',
              tourClass: 'tour-projects',
            },
            {
              to: '/project-updates',
              icon: <FaChartLine />,
              label: 'Project Progress',
              tourClass: 'tour-progress',
            },
          ],
        },
        {
          label: 'Communication',
          items: [
            {
              to: '/messages',
              icon: <FaEnvelope />,
              label: 'Messages',
              tourClass: 'tour-messages',

              // Unread message count
              badge: unreadMessages,
            },
            {
              to: '/payments',
              icon: <FaCreditCard />,
              label: 'Payments',
              tourClass: 'tour-payments',
            },
          ],
        },
      ];
    }

    // ========================================================
    // CLIENT — SHOP MODE
    // ========================================================

    if (
      user.role === 'client' &&
      currentMode === 'shop'
    ) {
      return [
        {
          label: 'Shop',
          items: [
            {
              to: '/ready-made-products',
              icon: <FaStore />,
              label: 'Browse',
              tourClass: 'tour-shop',
            },
            {
              to: '/cart',
              icon: <FaShoppingCart />,
              label: 'Cart',
            },
            {
              to: '/order-history',
              icon: <FaHistory />,
              label: 'Purchases History',
            },
          ],
        },
      ];
    }

    // ========================================================
    // ARTISAN — CUSTOM MODE
    // ========================================================

    if (
      user.role === 'artisan' &&
      currentMode === 'custom'
    ) {
      return [
        {
          label: 'Overview',
          items: [
            {
              to: '/artisan-dashboard',
              icon: <FaHome />,
              label: 'Dashboard',
              tourClass: 'tour-dashboard',
            },
            {
              to: '/browse-project-requests',
              icon: <FaClipboardList />,
              label: 'Browse Projects',
              tourClass: 'tour-browse-projects',
            },
          ],
        },
        {
          label: 'Work',
          items: [
            {
              to: '/my-projects',
              icon: <FaFolderOpen />,
              label: 'Ongoing Projects',
              tourClass: 'tour-my-projects',
            },
            {
              to: '/my-proposals',
              icon: <FaFileAlt />,
              label: 'Sent Proposals',
              tourClass: 'tour-my-proposals',
            },
          ],
        },
        {
          label: 'Communication',
          items: [
            {
              to: '/messaging',
              icon: <FaEnvelope />,
              label: 'Messages',
              tourClass: 'tour-messages',

              // Unread message count
              badge: unreadMessages,
            },
            {
              to: '/artisan-payments',
              icon: <FaCreditCard />,
              label: 'Payments',
              tourClass: 'tour-payments',
            },
          ],
        },
      ];
    }

    // ========================================================
    // ARTISAN — SHOP MODE
    // ========================================================

    if (
      user.role === 'artisan' &&
      currentMode === 'shop'
    ) {
      return [
        {
          label: 'Shop',
          items: [
            {
              to: '/artisan-ready-products',
              icon: <FaBoxOpen />,
              label: 'My Products',
            },
            {
              to: '/orders',
              icon: <FaTruck />,
              label: 'Orders',
            },
            {
              to: '/artisan-earnings',
              icon: <FaMoneyBillWave />,
              label: 'Earnings',
            },
          ],
        },
      ];
    }

    // ========================================================
    // ADMIN
    // ========================================================

    if (user.role === 'admin') {
      return [
        {
          label: 'Overview',
          items: [
            {
              to: '/admin-dashboard',
              icon: <FaHome />,
              label: 'Dashboard',
            },
          ],
        },
        {
          label: 'Management',
          items: [
            {
              to: '/users-management',
              icon: <FaUsers />,
              label: 'Users',
            },
            {
              to: '/projects-management',
              icon: <FaFolderOpen />,
              label: 'Projects',
            },
            {
              to: '/artisan-applications',
              icon: <FaUserCheck />,
              label: 'Artisan Applications',
            },
            {
              to: '/flagged-messages',
              icon: <FaFlag />,
              label: 'Flagged',
            },
          ],
        },
        {
          label: 'Finance',
          items: [
            {
              to: '/financials',
              icon: <FaMoneyBillWave />,
              label: 'Financials',
            },
            {
              to: '/disbursements',
              icon: <FaCreditCard />,
              label: 'Disbursements',
            },
          ],
        },
      ];
    }

    return [];
  };

  // ============================================================
  // NO USER
  // ============================================================

  if (!user) return null;

  // ============================================================
  // NAV DATA
  // ============================================================

  const navGroups = getNavGroups();

  const initials = (user.name || 'A')
    .split(' ')
    .map((n) => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  const roleLabel =
    user.role === 'admin'
      ? 'Administrator'
      : user.role === 'artisan'
        ? currentMode === 'custom'
          ? 'Artisan · Custom'
          : 'Artisan · Shop'
        : currentMode === 'custom'
          ? 'Client · Custom'
          : 'Client · Shop';

  const profilePath =
    user.role === 'artisan'
      ? '/artisan-profile'
      : user.role === 'client'
        ? '/Profile'
        : '/admin-profile';

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <>
      {/* ======================================================
          MOBILE TOP BAR
      ====================================================== */}

      <div className="sidebar-mobile-topbar d-lg-none">
        <button
          className="sidebar-hamburger"
          onClick={() => setMobileOpen(true)}
          aria-label="Open menu"
        >
          <FaBars />
        </button>

        <Link
          to="/"
          className="sidebar-mobile-logo"
        >
          <img
            src={Logo}
            alt="Artiza logo"
            className="logo"
          />
        </Link>

        <div className="sidebar-mobile-spacer" />
      </div>

      {/* ======================================================
          MOBILE BACKDROP
      ====================================================== */}

      {mobileOpen && (
        <div
          className="sidebar-backdrop d-lg-none"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* ======================================================
          SIDEBAR
      ====================================================== */}

      <aside
        className={`artiza-sidebar ${
          mobileOpen ? 'open' : ''
        }`}
      >
        {/* ==================================================
            HEADER
        ================================================== */}

        <div className="sidebar-header">
          <Link
            to="/"
            className="sidebar-logo"
          >
            <div className="logo-mark">
              <img
                src={Logo}
                alt="Artiza logo"
                className="logo"
              />
            </div>

            <span className="logo-text">
              Artiza
            </span>
          </Link>

          <button
            className="sidebar-close d-lg-none"
            onClick={() => setMobileOpen(false)}
            aria-label="Close menu"
          >
            <FaTimes />
          </button>
        </div>

        {/* ==================================================
            NAV
        ================================================== */}

        <nav className="sidebar-nav">
          {navGroups.map((group, gi) => (
            <div
              key={gi}
              className="nav-group"
            >
              <span className="nav-group-label">
                {group.label}
              </span>

              {group.items.map((item, ii) => (
                <SidebarLink
                  key={ii}
                  to={item.to}
                  icon={item.icon}
                  label={item.label}
                  tourClass={item.tourClass}
                  badge={item.badge}
                />
              ))}
            </div>
          ))}
        </nav>

        {/* ==================================================
            FOOTER
        ================================================== */}

        <div className="sidebar-footer">
          {shouldShowModeSwitch && (
            <button
              className="mode-switch-btn tour-mode-switch"
              onClick={
                user.role === 'client'
                  ? handleClientSwitch
                  : handleArtisanSwitch
              }
            >
              <span className="switch-icon">
                <FaExchangeAlt />
              </span>

              <span className="switch-text">
                {currentMode === 'custom'
                  ? 'Shop Mode'
                  : 'Custom Mode'}
              </span>

              <FaChevronRight className="switch-arrow" />
            </button>
          )}

          <button
            className="help-desk-btn tour-help-desk"
            onClick={handleHelpDeskClick}
          >
            <FaHeadset className="hd-icon" />
            <span>Help Desk</span>
          </button>

          {/* =================================================
              PROFILE + LOGOUT
          ================================================= */}

          <div className="footer-actions">
            <NavLink
              to={profilePath}
              className={({ isActive }) =>
                `footer-action-btn tour-user-menu ${
                  isActive ? 'active' : ''
                }`
              }
            >
              <FaUser className="fa-icon" />
              <span>Profile</span>
            </NavLink>

            <button
              onClick={handleLogout}
              className="footer-action-btn logout"
              type="button"
            >
              <FaSignOutAlt className="fa-icon" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </aside>
    </>
  );
}

// ============================================================
// SIDEBAR LINK
// ============================================================

function SidebarLink({
  to,
  icon,
  label,
  tourClass = '',
  badge,
}) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `sidebar-link ${tourClass} ${
          isActive ? 'active' : ''
        }`
      }
    >
      <span className="sidebar-link-icon">
        {icon}
      </span>

      <span className="sidebar-link-label">
        {label}
      </span>

      {badge > 0 && (
        <span className="sidebar-link-badge">
          {badge > 99 ? '99+' : badge}
        </span>
      )}

      <span className="sidebar-link-indicator" />
    </NavLink>
  );
}